import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SkeletonCard from '../../components/Redesing/skeleton/SkeletonCard';

/**
 * Skeleton component for the maintenance ticket detail page.
 * Mirrors the two-column layout: ticket details (left) and notes (right).
 */
function TicketDetailSkeleton() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Stack spacing={3}>
        {/* Back link */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={100} height={24} />
        </Stack>

        {/* Header: icon, title, chip, action buttons */}
        <Stack sx={{ pl: 2 }} spacing={0.5}>
          <Stack
            alignItems="flex-start"
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              <Skeleton variant="circular" width={64} height={64} />
              <Stack spacing={1}>
                <Skeleton variant="text" width={250} height={32} />
                <Stack alignItems="center" direction="row" spacing={1}>
                  <Skeleton variant="text" width={60} height={20} />
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={24}
                    sx={{ borderRadius: 1 }}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Skeleton
                variant="rectangular"
                width={70}
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={60}
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={65}
                height={36}
                sx={{ borderRadius: 1 }}
              />
            </Stack>
          </Stack>
        </Stack>

        {/* Two-column content */}
        <Grid container spacing={2}>
          {/* Left column - Ticket Details card */}
          <Grid xs={12} lg={5}>
            <SkeletonCard title rows={12} />
          </Grid>

          {/* Right column - Images + Notes */}
          <Grid xs={12} lg={7}>
            <Stack spacing={2}>
              {/* Images placeholder */}
              <SkeletonCard title height={120} />
              {/* Communication log / Notes */}
              <SkeletonCard title height={200} />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}

export default TicketDetailSkeleton;
